<template>
    <label class="block text-sm font-medium text-gray-700 required">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot /></span>
        <span v-if="extra">&nbsp;<small>({{ extra }})</small></span><span v-else><slot /></span>
    </label>
</template>

<script>
export default {
    props: ['value', 'extra']
}
</script>
